module.exports = __webpack_public_path__ + "img/offers9.26ba2343.webp";